$(document).ready(function(){
    $('.block__merchant-reviews-details-list-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        adaptiveHeight: true,
        asNavFor: '.block__merchant-reviews-details-image-slider',
        prevArrow: $('.block__merchant-reviews-details-arrow-prev'),
        nextArrow: $('.block__merchant-reviews-details-arrow-next')
    });
    $('.block__merchant-reviews-details-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.block__merchant-reviews-details-list-slider',
        arrows: false,
        dots: false
    });
});